import React from "react";
import Row from "@amzn/meridian/esm/components/row";
import Button from "@amzn/meridian/esm/components/button";
import Icon from "@amzn/meridian/esm/components/icon";
import Text from "@amzn/meridian/esm/components/text";
import gridTokens from "@amzn/meridian-tokens/base/icon/grid";
import Theme from "@amzn/meridian/esm/components/theme";

const SummaryListButton = ({ onSummaryListInClient }) => (
  <Row widths={["32px", "136px", "fill"]} spacing="none" spacingInset="none">
    <Row width="32px" />
    <Button type="link" size="small" onClick={onSummaryListInClient}>
      <Row widths={["10px", "20px", "10px", "84px", "fill"]} spacing="none" spacingInset="none">
        <Row width="10px" />
        <Icon tokens={gridTokens} color="success" />
        <Row width="10px" />
        <Theme tokens={{ textColorPrimary: "#006D5B" }}>
          <Text type="b200"> Summary list</Text>
        </Theme>
        <Row width="10px" />
      </Row>
    </Button>
  </Row>
);

export default SummaryListButton;
